export const area = [
    {
        "value": 156110000,
        "label": "北京市",
        "children": [
            {
                "value": 156110000,
                "label": "北京市"
            }
        ]
    },
    {
        "value": 156120000,
        "label": "天津市",
        "children": [
            {
                "value": 156120000,
                "label": "天津市"
            }
        ]
    },
    {
        "value": 156130000,
        "label": "河北省",
        "children": [
            {
                "value": 156130100,
                "label": "石家庄市"
            },
            {
                "value": 156130200,
                "label": "唐山市"
            },
            {
                "value": 156130300,
                "label": "秦皇岛市"
            },
            {
                "value": 156130400,
                "label": "邯郸市"
            },
            {
                "value": 156130500,
                "label": "邢台市"
            },
            {
                "value": 156130600,
                "label": "保定市"
            },
            {
                "value": 156130700,
                "label": "张家口市"
            },
            {
                "value": 156130800,
                "label": "承德市"
            },
            {
                "value": 156130900,
                "label": "沧州市"
            },
            {
                "value": 156131000,
                "label": "廊坊市"
            },
            {
                "value": 156131100,
                "label": "衡水市"
            }
        ]
    },
    {
        "value": 156140000,
        "label": "山西省",
        "children": [
            {
                "value": 156140100,
                "label": "太原市"
            },
            {
                "value": 156140200,
                "label": "大同市"
            },
            {
                "value": 156140300,
                "label": "阳泉市"
            },
            {
                "value": 156140400,
                "label": "长治市"
            },
            {
                "value": 156140500,
                "label": "晋城市"
            },
            {
                "value": 156140600,
                "label": "朔州市"
            },
            {
                "value": 156140700,
                "label": "晋中市"
            },
            {
                "value": 156140800,
                "label": "运城市"
            },
            {
                "value": 156140900,
                "label": "忻州市"
            },
            {
                "value": 156141000,
                "label": "临汾市"
            },
            {
                "value": 156141100,
                "label": "吕梁市"
            }
        ]
    },
    {
        "value": 156150000,
        "label": "内蒙古自治区",
        "children": [
            {
                "value": 156150100,
                "label": "呼和浩特市"
            },
            {
                "value": 156150200,
                "label": "包头市"
            },
            {
                "value": 156150300,
                "label": "乌海市"
            },
            {
                "value": 156150400,
                "label": "赤峰市"
            },
            {
                "value": 156150500,
                "label": "通辽市"
            },
            {
                "value": 156150600,
                "label": "鄂尔多斯市"
            },
            {
                "value": 156150700,
                "label": "呼伦贝尔市"
            },
            {
                "value": 156150800,
                "label": "巴彦淖尔市"
            },
            {
                "value": 156150900,
                "label": "乌兰察布市"
            },
            {
                "value": 156152200,
                "label": "兴安盟"
            },
            {
                "value": 156152500,
                "label": "锡林郭勒盟"
            },
            {
                "value": 156152900,
                "label": "阿拉善盟"
            }
        ]
    },
    {
        "value": 156210000,
        "label": "辽宁省",
        "children": [
            {
                "value": 156210100,
                "label": "沈阳市"
            },
            {
                "value": 156210200,
                "label": "大连市"
            },
            {
                "value": 156210300,
                "label": "鞍山市"
            },
            {
                "value": 156210400,
                "label": "抚顺市"
            },
            {
                "value": 156210500,
                "label": "本溪市"
            },
            {
                "value": 156210600,
                "label": "丹东市"
            },
            {
                "value": 156210700,
                "label": "锦州市"
            },
            {
                "value": 156210800,
                "label": "营口市"
            },
            {
                "value": 156210900,
                "label": "阜新市"
            },
            {
                "value": 156211000,
                "label": "辽阳市"
            },
            {
                "value": 156211100,
                "label": "盘锦市"
            },
            {
                "value": 156211200,
                "label": "铁岭市"
            },
            {
                "value": 156211300,
                "label": "朝阳市"
            },
            {
                "value": 156211400,
                "label": "葫芦岛市"
            }
        ]
    },
    {
        "value": 156220000,
        "label": "吉林省",
        "children": [
            {
                "value": 156220100,
                "label": "长春市"
            },
            {
                "value": 156220200,
                "label": "吉林市"
            },
            {
                "value": 156220300,
                "label": "四平市"
            },
            {
                "value": 156220400,
                "label": "辽源市"
            },
            {
                "value": 156220500,
                "label": "通化市"
            },
            {
                "value": 156220600,
                "label": "白山市"
            },
            {
                "value": 156220700,
                "label": "松原市"
            },
            {
                "value": 156220800,
                "label": "白城市"
            },
            {
                "value": 156222400,
                "label": "延边朝鲜族自治州"
            }
        ]
    },
    {
        "value": 156230000,
        "label": "黑龙江省",
        "children": [
            {
                "value": 156230100,
                "label": "哈尔滨市"
            },
            {
                "value": 156230200,
                "label": "齐齐哈尔市"
            },
            {
                "value": 156230300,
                "label": "鸡西市"
            },
            {
                "value": 156230400,
                "label": "鹤岗市"
            },
            {
                "value": 156230500,
                "label": "双鸭山市"
            },
            {
                "value": 156230600,
                "label": "大庆市"
            },
            {
                "value": 156230700,
                "label": "伊春市"
            },
            {
                "value": 156230800,
                "label": "佳木斯市"
            },
            {
                "value": 156230900,
                "label": "七台河市"
            },
            {
                "value": 156231000,
                "label": "牡丹江市"
            },
            {
                "value": 156231100,
                "label": "黑河市"
            },
            {
                "value": 156231200,
                "label": "绥化市"
            },
            {
                "value": 156232700,
                "label": "大兴安岭地区"
            }
        ]
    },
    {
        "value": 156310000,
        "label": "上海市",
        "children": [
            {
                "value": 156310000,
                "label": "上海市"
            }
        ]
    },
    {
        "value": 156320000,
        "label": "江苏省",
        "children": [
            {
                "value": 156320100,
                "label": "南京市"
            },
            {
                "value": 156320200,
                "label": "无锡市"
            },
            {
                "value": 156320300,
                "label": "徐州市"
            },
            {
                "value": 156320400,
                "label": "常州市"
            },
            {
                "value": 156320500,
                "label": "苏州市"
            },
            {
                "value": 156320600,
                "label": "南通市"
            },
            {
                "value": 156320700,
                "label": "连云港市"
            },
            {
                "value": 156320800,
                "label": "淮安市"
            },
            {
                "value": 156320900,
                "label": "盐城市"
            },
            {
                "value": 156321000,
                "label": "扬州市"
            },
            {
                "value": 156321100,
                "label": "镇江市"
            },
            {
                "value": 156321200,
                "label": "泰州市"
            },
            {
                "value": 156321300,
                "label": "宿迁市"
            }
        ]
    },
    {
        "value": 156330000,
        "label": "浙江省",
        "children": [
            {
                "value": 156330100,
                "label": "杭州市"
            },
            {
                "value": 156330200,
                "label": "宁波市"
            },
            {
                "value": 156330300,
                "label": "温州市"
            },
            {
                "value": 156330400,
                "label": "嘉兴市"
            },
            {
                "value": 156330500,
                "label": "湖州市"
            },
            {
                "value": 156330600,
                "label": "绍兴市"
            },
            {
                "value": 156330700,
                "label": "金华市"
            },
            {
                "value": 156330800,
                "label": "衢州市"
            },
            {
                "value": 156330900,
                "label": "舟山市"
            },
            {
                "value": 156331000,
                "label": "台州市"
            },
            {
                "value": 156331100,
                "label": "丽水市"
            }
        ]
    },
    {
        "value": 156340000,
        "label": "安徽省",
        "children": [
            {
                "value": 156340100,
                "label": "合肥市"
            },
            {
                "value": 156340200,
                "label": "芜湖市"
            },
            {
                "value": 156340300,
                "label": "蚌埠市"
            },
            {
                "value": 156340400,
                "label": "淮南市"
            },
            {
                "value": 156340500,
                "label": "马鞍山市"
            },
            {
                "value": 156340600,
                "label": "淮北市"
            },
            {
                "value": 156340700,
                "label": "铜陵市"
            },
            {
                "value": 156340800,
                "label": "安庆市"
            },
            {
                "value": 156341000,
                "label": "黄山市"
            },
            {
                "value": 156341100,
                "label": "滁州市"
            },
            {
                "value": 156341200,
                "label": "阜阳市"
            },
            {
                "value": 156341300,
                "label": "宿州市"
            },
            {
                "value": 156341500,
                "label": "六安市"
            },
            {
                "value": 156341600,
                "label": "亳州市"
            },
            {
                "value": 156341700,
                "label": "池州市"
            },
            {
                "value": 156341800,
                "label": "宣城市"
            }
        ]
    },
    {
        "value": 156350000,
        "label": "福建省",
        "children": [
            {
                "value": 156350100,
                "label": "福州市"
            },
            {
                "value": 156350200,
                "label": "厦门市"
            },
            {
                "value": 156350300,
                "label": "莆田市"
            },
            {
                "value": 156350400,
                "label": "三明市"
            },
            {
                "value": 156350500,
                "label": "泉州市"
            },
            {
                "value": 156350600,
                "label": "漳州市"
            },
            {
                "value": 156350700,
                "label": "南平市"
            },
            {
                "value": 156350800,
                "label": "龙岩市"
            },
            {
                "value": 156350900,
                "label": "宁德市"
            }
        ]
    },
    {
        "value": 156360000,
        "label": "江西省",
        "children": [
            {
                "value": 156360100,
                "label": "南昌市"
            },
            {
                "value": 156360200,
                "label": "景德镇市"
            },
            {
                "value": 156360300,
                "label": "萍乡市"
            },
            {
                "value": 156360400,
                "label": "九江市"
            },
            {
                "value": 156360500,
                "label": "新余市"
            },
            {
                "value": 156360600,
                "label": "鹰潭市"
            },
            {
                "value": 156360700,
                "label": "赣州市"
            },
            {
                "value": 156360800,
                "label": "吉安市"
            },
            {
                "value": 156360900,
                "label": "宜春市"
            },
            {
                "value": 156361000,
                "label": "抚州市"
            },
            {
                "value": 156361100,
                "label": "上饶市"
            }
        ]
    },
    {
        "value": 156370000,
        "label": "山东省",
        "children": [
            {
                "value": 156370100,
                "label": "济南市"
            },
            {
                "value": 156370200,
                "label": "青岛市"
            },
            {
                "value": 156370300,
                "label": "淄博市"
            },
            {
                "value": 156370400,
                "label": "枣庄市"
            },
            {
                "value": 156370500,
                "label": "东营市"
            },
            {
                "value": 156370600,
                "label": "烟台市"
            },
            {
                "value": 156370700,
                "label": "潍坊市"
            },
            {
                "value": 156370800,
                "label": "济宁市"
            },
            {
                "value": 156370900,
                "label": "泰安市"
            },
            {
                "value": 156371000,
                "label": "威海市"
            },
            {
                "value": 156371100,
                "label": "日照市"
            },
            {
                "value": 156371300,
                "label": "临沂市"
            },
            {
                "value": 156371400,
                "label": "德州市"
            },
            {
                "value": 156371500,
                "label": "聊城市"
            },
            {
                "value": 156371600,
                "label": "滨州市"
            },
            {
                "value": 156371700,
                "label": "菏泽市"
            }
        ]
    },
    {
        "value": 156410000,
        "label": "河南省",
        "children": [
            {
                "value": 156410100,
                "label": "郑州市"
            },
            {
                "value": 156410200,
                "label": "开封市"
            },
            {
                "value": 156410300,
                "label": "洛阳市"
            },
            {
                "value": 156410400,
                "label": "平顶山市"
            },
            {
                "value": 156410500,
                "label": "安阳市"
            },
            {
                "value": 156410600,
                "label": "鹤壁市"
            },
            {
                "value": 156410700,
                "label": "新乡市"
            },
            {
                "value": 156410800,
                "label": "焦作市"
            },
            {
                "value": 156410900,
                "label": "濮阳市"
            },
            {
                "value": 156411000,
                "label": "许昌市"
            },
            {
                "value": 156411100,
                "label": "漯河市"
            },
            {
                "value": 156411200,
                "label": "三门峡市"
            },
            {
                "value": 156411300,
                "label": "南阳市"
            },
            {
                "value": 156411400,
                "label": "商丘市"
            },
            {
                "value": 156411500,
                "label": "信阳市"
            },
            {
                "value": 156411600,
                "label": "周口市"
            },
            {
                "value": 156411700,
                "label": "驻马店市"
            },
            {
                "value": 156410000,
                "label": "河南省直辖"
            }
        ]
    },
    {
        "value": 156420000,
        "label": "湖北省",
        "children": [
            {
                "value": 156420100,
                "label": "武汉市"
            },
            {
                "value": 156420200,
                "label": "黄石市"
            },
            {
                "value": 156420300,
                "label": "十堰市"
            },
            {
                "value": 156420500,
                "label": "宜昌市"
            },
            {
                "value": 156420600,
                "label": "襄阳市"
            },
            {
                "value": 156420700,
                "label": "鄂州市"
            },
            {
                "value": 156420800,
                "label": "荆门市"
            },
            {
                "value": 156420900,
                "label": "孝感市"
            },
            {
                "value": 156421000,
                "label": "荆州市"
            },
            {
                "value": 156421100,
                "label": "黄冈市"
            },
            {
                "value": 156421200,
                "label": "咸宁市"
            },
            {
                "value": 156421300,
                "label": "随州市"
            },
            {
                "value": 156422800,
                "label": "恩施土家族苗族自治州"
            },
            {
                "value": 156420000,
                "label": "湖北省直辖"
            }
        ]
    },
    {
        "value": 156430000,
        "label": "湖南省",
        "children": [
            {
                "value": 156430100,
                "label": "长沙市"
            },
            {
                "value": 156430200,
                "label": "株洲市"
            },
            {
                "value": 156430300,
                "label": "湘潭市"
            },
            {
                "value": 156430400,
                "label": "衡阳市"
            },
            {
                "value": 156430500,
                "label": "邵阳市"
            },
            {
                "value": 156430600,
                "label": "岳阳市"
            },
            {
                "value": 156430700,
                "label": "常德市"
            },
            {
                "value": 156430800,
                "label": "张家界市"
            },
            {
                "value": 156430900,
                "label": "益阳市"
            },
            {
                "value": 156431000,
                "label": "郴州市"
            },
            {
                "value": 156431100,
                "label": "永州市"
            },
            {
                "value": 156431200,
                "label": "怀化市"
            },
            {
                "value": 156431300,
                "label": "娄底市"
            },
            {
                "value": 156433100,
                "label": "湘西土家族苗族自治州"
            }
        ]
    },
    {
        "value": 156440000,
        "label": "广东省",
        "children": [
            {
                "value": 156440100,
                "label": "广州市"
            },
            {
                "value": 156440200,
                "label": "韶关市"
            },
            {
                "value": 156440300,
                "label": "深圳市"
            },
            {
                "value": 156440400,
                "label": "珠海市"
            },
            {
                "value": 156440500,
                "label": "汕头市"
            },
            {
                "value": 156440600,
                "label": "佛山市"
            },
            {
                "value": 156440700,
                "label": "江门市"
            },
            {
                "value": 156440800,
                "label": "湛江市"
            },
            {
                "value": 156440900,
                "label": "茂名市"
            },
            {
                "value": 156441200,
                "label": "肇庆市"
            },
            {
                "value": 156441300,
                "label": "惠州市"
            },
            {
                "value": 156441400,
                "label": "梅州市"
            },
            {
                "value": 156441500,
                "label": "汕尾市"
            },
            {
                "value": 156441600,
                "label": "河源市"
            },
            {
                "value": 156441700,
                "label": "阳江市"
            },
            {
                "value": 156441800,
                "label": "清远市"
            },
            {
                "value": 156441900,
                "label": "东莞市"
            },
            {
                "value": 156442000,
                "label": "中山市"
            },
            {
                "value": 156445100,
                "label": "潮州市"
            },
            {
                "value": 156445200,
                "label": "揭阳市"
            },
            {
                "value": 156445300,
                "label": "云浮市"
            }
        ]
    },
    {
        "value": 156450000,
        "label": "广西壮族自治区",
        "children": [
            {
                "value": 156450100,
                "label": "南宁市"
            },
            {
                "value": 156450200,
                "label": "柳州市"
            },
            {
                "value": 156450300,
                "label": "桂林市"
            },
            {
                "value": 156450400,
                "label": "梧州市"
            },
            {
                "value": 156450500,
                "label": "北海市"
            },
            {
                "value": 156450600,
                "label": "防城港市"
            },
            {
                "value": 156450700,
                "label": "钦州市"
            },
            {
                "value": 156450800,
                "label": "贵港市"
            },
            {
                "value": 156450900,
                "label": "玉林市"
            },
            {
                "value": 156451000,
                "label": "百色市"
            },
            {
                "value": 156451100,
                "label": "贺州市"
            },
            {
                "value": 156451200,
                "label": "河池市"
            },
            {
                "value": 156451300,
                "label": "来宾市"
            },
            {
                "value": 156451400,
                "label": "崇左市"
            }
        ]
    },
    {
        "value": 156460000,
        "label": "海南省",
        "children": [
            {
                "value": 156460100,
                "label": "海口市"
            },
            {
                "value": 156460200,
                "label": "三亚市"
            },
            {
                "value": 156460300,
                "label": "三沙市"
            },
            {
                "value": 156460400,
                "label": "儋州市"
            },
            {
                "value": 156460000,
                "label": "海南省直辖"
            }
        ]
    },
    {
        "value": 156500000,
        "label": "重庆市",
        "children": [
            {
                "value": 156500000,
                "label": "重庆市"
            }
        ]
    },
    {
        "value": 156510000,
        "label": "四川省",
        "children": [
            {
                "value": 156510100,
                "label": "成都市"
            },
            {
                "value": 156510300,
                "label": "自贡市"
            },
            {
                "value": 156510400,
                "label": "攀枝花市"
            },
            {
                "value": 156510500,
                "label": "泸州市"
            },
            {
                "value": 156510600,
                "label": "德阳市"
            },
            {
                "value": 156510700,
                "label": "绵阳市"
            },
            {
                "value": 156510800,
                "label": "广元市"
            },
            {
                "value": 156510900,
                "label": "遂宁市"
            },
            {
                "value": 156511000,
                "label": "内江市"
            },
            {
                "value": 156511100,
                "label": "乐山市"
            },
            {
                "value": 156511300,
                "label": "南充市"
            },
            {
                "value": 156511400,
                "label": "眉山市"
            },
            {
                "value": 156511500,
                "label": "宜宾市"
            },
            {
                "value": 156511600,
                "label": "广安市"
            },
            {
                "value": 156511700,
                "label": "达州市"
            },
            {
                "value": 156511800,
                "label": "雅安市"
            },
            {
                "value": 156511900,
                "label": "巴中市"
            },
            {
                "value": 156512000,
                "label": "资阳市"
            },
            {
                "value": 156513200,
                "label": "阿坝藏族羌族自治州"
            },
            {
                "value": 156513300,
                "label": "甘孜藏族自治州"
            },
            {
                "value": 156513400,
                "label": "凉山彝族自治州"
            }
        ]
    },
    {
        "value": 156520000,
        "label": "贵州省",
        "children": [
            {
                "value": 156520100,
                "label": "贵阳市"
            },
            {
                "value": 156520200,
                "label": "六盘水市"
            },
            {
                "value": 156520300,
                "label": "遵义市"
            },
            {
                "value": 156520400,
                "label": "安顺市"
            },
            {
                "value": 156520500,
                "label": "毕节市"
            },
            {
                "value": 156520600,
                "label": "铜仁市"
            },
            {
                "value": 156522300,
                "label": "黔西南布依族苗族自治州"
            },
            {
                "value": 156522600,
                "label": "黔东南苗族侗族自治州"
            },
            {
                "value": 156522700,
                "label": "黔南布依族苗族自治州"
            }
        ]
    },
    {
        "value": 156530000,
        "label": "云南省",
        "children": [
            {
                "value": 156530100,
                "label": "昆明市"
            },
            {
                "value": 156530300,
                "label": "曲靖市"
            },
            {
                "value": 156530400,
                "label": "玉溪市"
            },
            {
                "value": 156530500,
                "label": "保山市"
            },
            {
                "value": 156530600,
                "label": "昭通市"
            },
            {
                "value": 156530700,
                "label": "丽江市"
            },
            {
                "value": 156530800,
                "label": "普洱市"
            },
            {
                "value": 156530900,
                "label": "临沧市"
            },
            {
                "value": 156532300,
                "label": "楚雄彝族自治州"
            },
            {
                "value": 156532500,
                "label": "红河哈尼族彝族自治州"
            },
            {
                "value": 156532600,
                "label": "文山壮族苗族自治州"
            },
            {
                "value": 156532800,
                "label": "西双版纳傣族自治州"
            },
            {
                "value": 156532900,
                "label": "大理白族自治州"
            },
            {
                "value": 156533100,
                "label": "德宏傣族景颇族自治州"
            },
            {
                "value": 156533300,
                "label": "怒江傈僳族自治州"
            },
            {
                "value": 156533400,
                "label": "迪庆藏族自治州"
            }
        ]
    },
    {
        "value": 156540000,
        "label": "西藏自治区",
        "children": [
            {
                "value": 156540100,
                "label": "拉萨市"
            },
            {
                "value": 156540200,
                "label": "日喀则市"
            },
            {
                "value": 156540300,
                "label": "昌都市"
            },
            {
                "value": 156540400,
                "label": "林芝市"
            },
            {
                "value": 156540500,
                "label": "山南市"
            },
            {
                "value": 156540600,
                "label": "那曲市"
            },
            {
                "value": 156542500,
                "label": "阿里地区"
            }
        ]
    },
    {
        "value": 156610000,
        "label": "陕西省",
        "children": [
            {
                "value": 156610100,
                "label": "西安市"
            },
            {
                "value": 156610200,
                "label": "铜川市"
            },
            {
                "value": 156610300,
                "label": "宝鸡市"
            },
            {
                "value": 156610400,
                "label": "咸阳市"
            },
            {
                "value": 156610500,
                "label": "渭南市"
            },
            {
                "value": 156610600,
                "label": "延安市"
            },
            {
                "value": 156610700,
                "label": "汉中市"
            },
            {
                "value": 156610800,
                "label": "榆林市"
            },
            {
                "value": 156610900,
                "label": "安康市"
            },
            {
                "value": 156611000,
                "label": "商洛市"
            }
        ]
    },
    {
        "value": 156620000,
        "label": "甘肃省",
        "children": [
            {
                "value": 156620100,
                "label": "兰州市"
            },
            {
                "value": 156620200,
                "label": "嘉峪关市"
            },
            {
                "value": 156620300,
                "label": "金昌市"
            },
            {
                "value": 156620400,
                "label": "白银市"
            },
            {
                "value": 156620500,
                "label": "天水市"
            },
            {
                "value": 156620600,
                "label": "武威市"
            },
            {
                "value": 156620700,
                "label": "张掖市"
            },
            {
                "value": 156620800,
                "label": "平凉市"
            },
            {
                "value": 156620900,
                "label": "酒泉市"
            },
            {
                "value": 156621000,
                "label": "庆阳市"
            },
            {
                "value": 156621100,
                "label": "定西市"
            },
            {
                "value": 156621200,
                "label": "陇南市"
            },
            {
                "value": 156622900,
                "label": "临夏回族自治州"
            },
            {
                "value": 156623000,
                "label": "甘南藏族自治州"
            },
            {
                "value": 156620000,
                "label": "甘肃省直辖"
            }
        ]
    },
    {
        "value": 156630000,
        "label": "青海省",
        "children": [
            {
                "value": 156630100,
                "label": "西宁市"
            },
            {
                "value": 156630200,
                "label": "海东市"
            },
            {
                "value": 156632200,
                "label": "海北藏族自治州"
            },
            {
                "value": 156632300,
                "label": "黄南藏族自治州"
            },
            {
                "value": 156632500,
                "label": "海南藏族自治州"
            },
            {
                "value": 156632600,
                "label": "果洛藏族自治州"
            },
            {
                "value": 156632700,
                "label": "玉树藏族自治州"
            },
            {
                "value": 156632800,
                "label": "海西蒙古族藏族自治州"
            }
        ]
    },
    {
        "value": 156640000,
        "label": "宁夏回族自治区",
        "children": [
            {
                "value": 156640100,
                "label": "银川市"
            },
            {
                "value": 156640200,
                "label": "石嘴山市"
            },
            {
                "value": 156640300,
                "label": "吴忠市"
            },
            {
                "value": 156640400,
                "label": "固原市"
            },
            {
                "value": 156640500,
                "label": "中卫市"
            }
        ]
    },
    {
        "value": 156650000,
        "label": "新疆维吾尔自治区",
        "children": [
            {
                "value": 156650100,
                "label": "乌鲁木齐市"
            },
            {
                "value": 156650200,
                "label": "克拉玛依市"
            },
            {
                "value": 156650400,
                "label": "吐鲁番市"
            },
            {
                "value": 156650500,
                "label": "哈密市"
            },
            {
                "value": 156652300,
                "label": "昌吉回族自治州"
            },
            {
                "value": 156652700,
                "label": "博尔塔拉蒙古自治州"
            },
            {
                "value": 156652800,
                "label": "巴音郭楞蒙古自治州"
            },
            {
                "value": 156652900,
                "label": "阿克苏地区"
            },
            {
                "value": 156653000,
                "label": "克孜勒苏柯尔克孜自治州"
            },
            {
                "value": 156653100,
                "label": "喀什地区"
            },
            {
                "value": 156653200,
                "label": "和田地区"
            },
            {
                "value": 156654000,
                "label": "伊犁哈萨克自治州"
            },
            {
                "value": 156654200,
                "label": "塔城地区"
            },
            {
                "value": 156654300,
                "label": "阿勒泰地区"
            },
            {
                "value": 156650000,
                "label": "新疆维吾尔自治区直辖"
            }
        ]
    },
    {
        "value": 156710000,
        "label": "台湾省",
        "children": [
            {
                "value": 156710000,
                "label": "台湾省"
            }
        ]
    },
    {
        "value": 156810000,
        "label": "香港特别行政区",
        "children": [
            {
                "value": 156810000,
                "label": "香港特别行政区"
            }
        ]
    },
    {
        "value": 156820000,
        "label": "澳门特别行政区",
        "children": [
            {
                "value": 156820000,
                "label": "澳门特别行政区"
            }
        ]
    }
]